import React, { useEffect } from 'react';

const ComparisonPortal = () => {
  useEffect(() => {
    // Create and append the widget container
    const widgetContainer = document.createElement('div');
    widgetContainer.id = 'c24pp-mobileservice-iframe';
    widgetContainer.style.cssText = `
      width: 100%;
      min-height: 3000px;
      height: auto !important;
      border: none;
      background-color: #fff;
      overflow: visible !important;
      position: relative;
      z-index: 1;
      display: block;
      margin: 0;
      padding: 0;
    `;

    // Get the parent container reference
    const container = document.getElementById('check24-widget-container');
    if (container) {
      container.innerHTML = ''; // Clear any existing content
      container.appendChild(widgetContainer);

      // Create and append the Check24 script
      const script = document.createElement('script');
      script.src = 'https://files.check24.net/widgets/auto/380069/c24pp-mobileservice-iframe/sim-only-iframe.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    // Cleanup function
    return () => {
      const script = document.querySelector('script[src*="c24pp-mobileservice-iframe"]');
      if (script?.parentNode) {
        script.parentNode.removeChild(script);
      }
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Handytarife vergleichen</h2>
        <p className="text-gray-600 mb-6">
          Vergleichen Sie die besten Handytarife von über 30 Anbietern und finden Sie den perfekten Tarif für Ihre Bedürfnisse.
        </p>
      </div>

      <div 
        id="check24-widget-container" 
        className="w-full border border-gray-200 rounded-lg overflow-visible bg-white"
        style={{
          minHeight: '3000px',
          height: 'auto !important',
          position: 'relative',
          zIndex: 1,
          overflow: 'visible',
          display: 'block',
          margin: 0,
          padding: 0
        }}
      ></div>

      <div className="mt-6 text-sm text-gray-500">
        Powered by CHECK24 - Deutschlands größtes Vergleichsportal
      </div>
    </div>
  );
};

export default ComparisonPortal;